module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('fieldset', {
    attrs: {
      "disabled": _vm.formDisabled
    }
  }, [_c('loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }]
  }), _vm._v(" "), _c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }],
    staticClass: "form form-horizontal",
    attrs: {
      "data-vv-scope": "buildingForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('h4', [_vm._v("Attachment " + _vm._s(_vm.buildingDto.attachmentNumber) + " of " + _vm._s(_vm.attachmentCount) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', [_vm._v("Attachment ID:")]), _vm._v(" " + _vm._s(_vm.buildingDto.dbNumber) + "\n                ")])]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('label', {
    staticClass: "col-md-3"
  }, [_vm._v("Attachment Selection:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.qaqcSelection.attachmentSelection),
      expression: "qaqcSelection.attachmentSelection"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.qaqcSelection, "attachmentSelection", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": -1
    }
  }, [_vm._v("Attachment Selection")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("Add As New Production Attachment")]), _vm._v(" "), _vm._l((_vm.productionAttachmentList), function(attachment) {
    return _c('option', {
      key: attachment.historicBuildingFormId,
      domProps: {
        "value": attachment.historicBuildingFormId
      }
    }, [_vm._v("\n                            Update Production Attachment: " + _vm._s(attachment.dbNumber) + "\n                        ")])
  })], 2)])]) : _vm._e(), _vm._v(" "), (this.isSegment) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label text-label"
  }, [_vm._v("Building Contribution")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.buildingDto.contributionId),
      expression: "buildingDto.contributionId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.buildingDto, "contributionId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.contributionList), function(contribution) {
    return _c('option', {
      key: contribution.contributionId,
      domProps: {
        "value": contribution.contributionId
      }
    }, [_vm._v("\n                            " + _vm._s(contribution.description) + "\n                        ")])
  })], 2)]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'contributionId',
      "hasAppend": false
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    class: {
      'has-error': _vm.errors.has('buildingForm.historicName')
    }
  }, [_c('label', {
    staticClass: "col-md-2 col-md-offset-2 control-label text-label"
  }, [_vm._v("Historic Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.buildingDto.historicName),
      expression: "buildingDto.historicName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255'),
      expression: "'required|max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "historicName"
    },
    domProps: {
      "value": (_vm.buildingDto.historicName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.buildingDto, "historicName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('buildingForm.historicName')),
      expression: "errors.has('buildingForm.historicName')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('buildingForm.historicName')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "11px",
      "float": "right"
    }
  }, [_vm._v(_vm._s((_vm.buildingDto.historicName || '').length + '/255'))]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'historicName',
      "hasAppend": true
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    class: {
      'has-error': _vm.errors.has('buildingForm.otherCommonNames')
    }
  }, [_c('label', {
    staticClass: "col-md-2 col-md-offset-2 control-label text-label"
  }, [_vm._v("Other Common Names")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.buildingDto.otherCommonNames),
      expression: "buildingDto.otherCommonNames"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:255'),
      expression: "'max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "otherCommonNames"
    },
    domProps: {
      "value": (_vm.buildingDto.otherCommonNames)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.buildingDto, "otherCommonNames", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('buildingForm.otherCommonNames')),
      expression: "errors.has('buildingForm.otherCommonNames')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('buildingForm.otherCommonNames')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "11px",
      "float": "right"
    }
  }, [_vm._v(_vm._s((_vm.buildingDto.otherCommonNames || '').length + '/255'))]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'otherCommonNames',
      "hasAppend": true
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 col-sm-offset-2 control-label text-label"
  }, [_vm._v("Current Function Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [(_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'selectedCurrentFunction',
      "hasAppend": true
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.functionList), function(t) {
    return _c('div', {
      key: t.buildingFunctionId,
      staticClass: "checkbox checkbox-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedCurrentFunction),
        expression: "selectedCurrentFunction"
      }],
      attrs: {
        "type": "checkbox",
        "id": _vm.qaqcFieldId + 'currentFunction' + t.description
      },
      domProps: {
        "value": t.buildingFunctionId,
        "checked": Array.isArray(_vm.selectedCurrentFunction) ? _vm._i(_vm.selectedCurrentFunction, t.buildingFunctionId) > -1 : (_vm.selectedCurrentFunction)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedCurrentFunction,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = t.buildingFunctionId,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedCurrentFunction = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedCurrentFunction = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedCurrentFunction = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": _vm.qaqcFieldId + 'currentFunction' + t.description
      }
    }, [_vm._v(_vm._s(t.description))])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 col-sm-offset-2 control-label text-label"
  }, [_vm._v("Historic Function Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [(_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'selectedHistoricFunction',
      "hasAppend": true
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.functionList), function(t) {
    return _c('div', {
      key: t.buildingFunctionId,
      staticClass: "checkbox checkbox-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedHistoricFunction),
        expression: "selectedHistoricFunction"
      }],
      attrs: {
        "type": "checkbox",
        "id": _vm.qaqcFieldId + 'historicFunction' + t.description
      },
      domProps: {
        "value": t.buildingFunctionId,
        "checked": Array.isArray(_vm.selectedHistoricFunction) ? _vm._i(_vm.selectedHistoricFunction, t.buildingFunctionId) > -1 : (_vm.selectedHistoricFunction)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedHistoricFunction,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = t.buildingFunctionId,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedHistoricFunction = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedHistoricFunction = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedHistoricFunction = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": _vm.qaqcFieldId + 'historicFunction' + t.description
      }
    }, [_vm._v(_vm._s(t.description))])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 col-sm-offset-2 control-label text-label"
  }, [_vm._v("Current Setting Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [(_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'selectedCurrentSetting',
      "hasAppend": true
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.settingList), function(t) {
    return _c('div', {
      key: t.buildingSettingId,
      staticClass: "checkbox checkbox-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedCurrentSetting),
        expression: "selectedCurrentSetting"
      }],
      attrs: {
        "type": "checkbox",
        "id": _vm.qaqcFieldId + 'currentSetting' + t.description
      },
      domProps: {
        "value": t.buildingSettingId,
        "checked": Array.isArray(_vm.selectedCurrentSetting) ? _vm._i(_vm.selectedCurrentSetting, t.buildingSettingId) > -1 : (_vm.selectedCurrentSetting)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedCurrentSetting,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = t.buildingSettingId,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedCurrentSetting = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedCurrentSetting = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedCurrentSetting = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": _vm.qaqcFieldId + 'currentSetting' + t.description
      }
    }, [_vm._v(_vm._s(t.description))])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 col-sm-offset-2 control-label text-label"
  }, [_vm._v("Historic Setting Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [(_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'selectedHistoricSetting',
      "hasAppend": true
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.settingList), function(t) {
    return _c('div', {
      key: t.buildingSettingId,
      staticClass: "checkbox checkbox-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedHistoricSetting),
        expression: "selectedHistoricSetting"
      }],
      attrs: {
        "type": "checkbox",
        "id": _vm.qaqcFieldId + 'historicSetting' + t.description
      },
      domProps: {
        "value": t.buildingSettingId,
        "checked": Array.isArray(_vm.selectedHistoricSetting) ? _vm._i(_vm.selectedHistoricSetting, t.buildingSettingId) > -1 : (_vm.selectedHistoricSetting)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedHistoricSetting,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = t.buildingSettingId,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedHistoricSetting = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedHistoricSetting = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedHistoricSetting = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": _vm.qaqcFieldId + 'historicSetting' + t.description
      }
    }, [_vm._v(_vm._s(t.description))])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 col-md-offset-2 control-label text-label"
  }, [_vm._v("Setting Decription")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.buildingDto.settingDescription),
      expression: "buildingDto.settingDescription"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.buildingDto.settingDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.buildingDto, "settingDescription", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'settingDescription',
      "hasAppend": true
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'buildingStyleId',
      "hasAppend": false
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    class: {
      'has-error': _vm.errors.has('buildingForm.buildingStyleId')
    }
  }, [_c('label', {
    staticClass: "col-md-1 control-label"
  }, [_vm._v("Style")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.buildingDto.buildingStyleId),
      expression: "buildingDto.buildingStyleId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !_vm.buildingDto.isNonExtant
      }),
      expression: "{ required: !buildingDto.isNonExtant }"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "buildingStyleId"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.buildingDto, "buildingStyleId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.buildingStyleList), function(style) {
    return _c('option', {
      key: style.buildingStyleId,
      domProps: {
        "value": style.buildingStyleId
      }
    }, [_vm._v("\n                                        " + _vm._s(style.description) + "\n                                    ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('buildingForm.buildingStyleId')),
      expression: "errors.has('buildingForm.buildingStyleId')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('buildingForm.buildingStyleId')))])])]), _vm._v(" "), _c('div', {
    class: {
      'has-error': _vm.errors.has('buildingForm.buildingTypeId')
    }
  }, [_c('label', {
    staticClass: "col-md-1 control-label"
  }, [_vm._v("Type/Form")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.buildingDto.buildingTypeId),
      expression: "buildingDto.buildingTypeId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !_vm.buildingDto.isNonExtant
      }),
      expression: "{ required: !buildingDto.isNonExtant }"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "buildingTypeId"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.buildingDto, "buildingTypeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.buildingTypeList), function(buildingType) {
    return _c('option', {
      key: buildingType.buildingTypeId,
      attrs: {
        "disabled": buildingType.isHeader
      },
      domProps: {
        "value": buildingType.buildingTypeId
      }
    }, [_vm._v("\n                                        " + _vm._s(buildingType.description) + "\n                                    ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('buildingForm.buildingTypeId')),
      expression: "errors.has('buildingForm.buildingTypeId')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('buildingForm.buildingTypeId')))])])]), _vm._v(" "), _c('div', {
    class: {
      'has-error': _vm.errors.has('buildingForm.storyId')
    }
  }, [_c('label', {
    staticClass: "col-md-1 control-label"
  }, [_vm._v("Stories")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.buildingDto.storyId),
      expression: "buildingDto.storyId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !_vm.buildingDto.isNonExtant
      }),
      expression: "{ required: !buildingDto.isNonExtant }"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "storyId"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.buildingDto, "storyId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.storyList), function(story) {
    return _c('option', {
      key: story.storyId,
      domProps: {
        "value": story.storyId
      }
    }, [_vm._v("\n                                        " + _vm._s(story.description) + "\n                                    ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('buildingForm.storyId')),
      expression: "errors.has('buildingForm.storyId')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('buildingForm.storyId')))])])]), _vm._v(" "), _c('div', {
    class: {
      'has-error': _vm.errors.has('buildingForm.yesNoBasementId')
    }
  }, [_c('label', {
    staticClass: "col-md-1 control-label"
  }, [_vm._v("Basement")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.buildingDto.yesNoBasementId),
      expression: "buildingDto.yesNoBasementId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !_vm.buildingDto.isNonExtant
      }),
      expression: "{ required: !buildingDto.isNonExtant }"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "yesNoBasementId"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.buildingDto, "yesNoBasementId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.yesNoList), function(yn) {
    return _c('option', {
      key: yn.yesNoId,
      domProps: {
        "value": yn.yesNoId
      }
    }, [_vm._v("\n                                        " + _vm._s(yn.description) + "\n                                    ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('buildingForm.yesNoBasementId')),
      expression: "errors.has('buildingForm.yesNoBasementId')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('buildingForm.yesNoBasementId')))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.buildingDto.historicBuildingElementList), function(element) {
    return _c('tr', {
      key: element.buildingElementId
    }, [_c('td', {
      staticClass: "form-inline"
    }, [_c('strong', [_vm._v(_vm._s(element.description))]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
      attrs: {
        "fieldData": _vm.qaqcSelection,
        "fieldName": 'historicBuildingElementList' + element.buildingElementId,
        "hasAppend": false
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('td', {
      class: {
        'has-error': _vm.errors.has('buildingForm.buildingElementTypeId' + element.buildingElementId)
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (element.buildingElementTypeId),
        expression: "element.buildingElementTypeId"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: !_vm.buildingDto.isNonExtant
        }),
        expression: "{ required: !buildingDto.isNonExtant }"
      }],
      staticClass: "form-control",
      attrs: {
        "name": 'buildingElementTypeId' + element.buildingElementId
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(element, "buildingElementTypeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "disabled": "",
        "value": ""
      }
    }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.elementTypeList.filter(function (x) {
      return x.buildingElementId === element.buildingElementId || !x.buildingElementId
    })), function(elementType) {
      return _c('option', {
        key: elementType.elementTypeId,
        domProps: {
          "value": elementType.elementTypeId
        }
      }, [_vm._v("\n                                            " + _vm._s(elementType.description) + "\n                                        ")])
    })], 2), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('buildingForm.buildingElementTypeId' + element.buildingElementId)),
        expression: "errors.has('buildingForm.buildingElementTypeId' + element.buildingElementId)"
      }],
      staticClass: "has-error"
    }, [_vm._v("Required")])]), _vm._v(" "), _c('td', {
      class: {
        'has-error': _vm.errors.has('buildingForm.buildingElementMaterialId' + element.buildingElementId)
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (element.buildingElementMaterialId),
        expression: "element.buildingElementMaterialId"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: !_vm.buildingDto.isNonExtant
        }),
        expression: "{ required: !buildingDto.isNonExtant }"
      }],
      staticClass: "form-control",
      attrs: {
        "name": 'buildingElementMaterialId' + element.buildingElementId
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(element, "buildingElementMaterialId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "disabled": "",
        "value": ""
      }
    }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.elementMaterialList.filter(function (x) {
      return x.buildingElementId === element.buildingElementId || !x.buildingElementId
    })), function(elementType) {
      return _c('option', {
        key: elementType.elementMaterialId,
        domProps: {
          "value": elementType.elementMaterialId
        }
      }, [_vm._v("\n                                            " + _vm._s(elementType.description) + "\n                                        ")])
    })], 2), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('buildingForm.buildingElementMaterialId' + element.buildingElementId)),
        expression: "errors.has('buildingForm.buildingElementMaterialId' + element.buildingElementId)"
      }],
      staticClass: "has-error"
    }, [_vm._v("Required")])])])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-1 col-md-offset-2 control-label text-label"
  }, [_vm._v("Notable Features")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.buildingDto.notableFeatures),
      expression: "buildingDto.notableFeatures"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.buildingDto.notableFeatures)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.buildingDto, "notableFeatures", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'notableFeatures',
      "hasAppend": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-1 col-md-offset-2 control-label text-label"
  }, [_vm._v("Landscaping")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.buildingDto.landscaping),
      expression: "buildingDto.landscaping"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.buildingDto.landscaping)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.buildingDto, "landscaping", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'landscaping',
      "hasAppend": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-1 col-md-offset-2 control-label text-label"
  }, [_vm._v("Architectural Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.buildingDto.architecturalDescription),
      expression: "buildingDto.architecturalDescription"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.buildingDto.architecturalDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.buildingDto, "architecturalDescription", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'architecturalDescription',
      "hasAppend": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    class: {
      'has-error': _vm.errors.has('buildingForm.buildingIntegrityId')
    }
  }, [_c('label', {
    staticClass: "col-md-1 col-md-offset-2 control-label text-label"
  }, [_vm._v("Integrity")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 form-inline"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.buildingDto.buildingIntegrityId),
      expression: "buildingDto.buildingIntegrityId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !_vm.buildingDto.isNonExtant
      }),
      expression: "{ required: !buildingDto.isNonExtant }"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "buildingIntegrityId"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.buildingDto, "buildingIntegrityId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.buildingIntegrityList), function(integrity) {
    return _c('option', {
      key: integrity.buildingIntegrityId,
      domProps: {
        "value": integrity.buildingIntegrityId
      }
    }, [_vm._v("\n                                " + _vm._s(integrity.description) + "\n                            ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('buildingForm.buildingIntegrityId')),
      expression: "errors.has('buildingForm.buildingIntegrityId')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('buildingForm.buildingIntegrityId')))]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'buildingIntegrityId',
      "hasAppend": false
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    class: {
      'has-error': _vm.errors.has('buildingForm.buildingConditionId')
    }
  }, [_c('label', {
    staticClass: "col-md-1 control-label text-label"
  }, [_vm._v("Condition")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 form-inline"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.buildingDto.buildingConditionId),
      expression: "buildingDto.buildingConditionId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !_vm.buildingDto.isNonExtant
      }),
      expression: "{ required: !buildingDto.isNonExtant }"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "buildingConditionId"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.buildingDto, "buildingConditionId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.buildingConditionList), function(condition) {
    return _c('option', {
      key: condition.buildingConditionId,
      domProps: {
        "value": condition.buildingConditionId
      }
    }, [_vm._v("\n                                " + _vm._s(condition.description) + "\n                            ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('buildingForm.buildingConditionId')),
      expression: "errors.has('buildingForm.buildingConditionId')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('buildingForm.buildingConditionId')))]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'buildingConditionId',
      "hasAppend": false
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('buildingForm.comment')
    }
  }, [_c('label', {
    staticClass: "col-md-1 col-md-offset-2 control-label text-label"
  }, [_vm._v("Comments")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.buildingDto.comment),
      expression: "buildingDto.comment"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !_vm.buildingDto.isNonExtant
      }),
      expression: "{ required: !buildingDto.isNonExtant }"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "comment"
    },
    domProps: {
      "value": (_vm.buildingDto.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.buildingDto, "comment", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('buildingForm.comment')),
      expression: "errors.has('buildingForm.comment')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('buildingForm.comment')))])]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'comment',
      "hasAppend": false
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-10 col-md-offset-2"
  }, [(_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'historicBuildingConstructionDateList',
      "hasAppend": true
    }
  }) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(6), _vm._v(" "), _c('tbody', _vm._l((_vm.constructionDates), function(date, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(date.constructionDateTypeDescription))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(date.date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(date.isEstimate ? 'Yes' : 'No'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(date.comment))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(date.source))]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "fa fa-ban",
      staticStyle: {
        "font-size": "18px"
      },
      on: {
        "click": function($event) {
          _vm.removeConstructionDate(index)
        }
      }
    })])])
  }))])], 1)]), _vm._v(" "), (!_vm.formDisabled) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-1 col-md-offset-10"
  }, [_c('button', {
    staticClass: "form-contol btn",
    on: {
      "click": function($event) {
        _vm.$refs['constructionDateModal'].open()
      }
    }
  }, [_vm._v("Add Construction Dates")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-1 col-md-offset-2 control-label text-label"
  }, [_vm._v("Architect(s) / Builder(s)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.buildingDto.architect),
      expression: "buildingDto.architect"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.buildingDto.architect)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.buildingDto, "architect", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'architect',
      "hasAppend": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-1 col-md-offset-2 control-label text-label"
  }, [_vm._v("Historic Function(s)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.buildingDto.historicFunction),
      expression: "buildingDto.historicFunction"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.buildingDto.historicFunction)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.buildingDto, "historicFunction", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'historicFunction',
      "hasAppend": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-1 col-md-offset-2 control-label text-label"
  }, [_vm._v("Alterations")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.buildingDto.alteration),
      expression: "buildingDto.alteration"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.buildingDto.alteration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.buildingDto, "alteration", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'alteration',
      "hasAppend": true
    }
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.qaqcEnabled) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("File Attachments")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(7), _vm._v(" "), _c('tbody', _vm._l((_vm.mediaList), function(mediaItem) {
    return _c('tr', {
      key: mediaItem.mediaId
    }, [_c('td', [_c('div', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('a', {
      staticClass: "fa fa-cloud-download",
      staticStyle: {
        "font-size": "18px"
      },
      attrs: {
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          _vm.mediaDownloadRow(mediaItem.mediaId, mediaItem.mediaTypeId, mediaItem.mediaSubtypeId, mediaItem.parentId, mediaItem.filename)
        }
      }
    })])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(mediaItem.filename))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(mediaItem.comment))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(mediaItem.createdBy))])])
  }))])])]) : _vm._e(), _vm._v(" "), (!(_vm.formDisabled || _vm.qaqcEnabled)) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-3 col-md-offset-2"
  }, [_c('input', {
    ref: "newFile",
    staticClass: "form-control",
    attrs: {
      "name": "newFile",
      "type": "file"
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-md-1 control-label text-label"
  }, [_vm._v("Comment")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.imageComment),
      expression: "imageComment"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.imageComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.imageComment = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary col-md-1",
    on: {
      "click": _vm.addBuildingFile
    }
  }, [_vm._v("Add")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'isNonExtant',
      "hasAppend": false
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.buildingDto.isNonExtant),
      expression: "buildingDto.isNonExtant"
    }],
    staticStyle: {
      "width": "20px",
      "height": "20px"
    },
    attrs: {
      "type": "checkbox",
      "id": _vm.qaqcFieldId + 'hbfIsNonExtant'
    },
    domProps: {
      "checked": Array.isArray(_vm.buildingDto.isNonExtant) ? _vm._i(_vm.buildingDto.isNonExtant, null) > -1 : (_vm.buildingDto.isNonExtant)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.buildingDto.isNonExtant,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.buildingDto.isNonExtant = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.buildingDto.isNonExtant = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.buildingDto, "isNonExtant", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "control-label text-label",
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "for": _vm.qaqcFieldId + 'hbfIsNonExtant'
    }
  }, [_vm._v("Non-Extant")])], 1)])])], 1), _vm._v(" "), _c('form', {
    staticClass: "form form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4 text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "disabled": _vm.currentAttachmentNumber === 1
    },
    on: {
      "click": _vm.previousHistoricBuilding
    }
  }, [_vm._v("Previous")])]), _vm._v(" "), (!(_vm.formDisabled)) ? _c('div', {
    staticClass: "col-xs-4 text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.qaqcEnabled ? _vm.completeSection('historicBuilding') : _vm.saveHistoricBuilding()
      }
    }
  }, [_vm._v("Save")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.dtoIsNew || _vm.currentAttachmentNumber >= _vm.attachmentCount
    },
    on: {
      "click": _vm.nextHistoricBuilding
    }
  }, [_vm._v("Next")])])]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldFooter', {
    attrs: {
      "qaqcProgressDto": _vm.qaqcProgressDto,
      "qaqcSelection": _vm.qaqcSelection,
      "sectionName": 'historicBuilding',
      "completeSection": _vm.completeSection
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('modal', {
    ref: "constructionDateModal"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v("Construction Dates")]), _vm._v(" "), _c('button', {
    staticClass: "btn pull-right",
    on: {
      "click": function($event) {
        _vm.$refs['constructionDateModal'].close()
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "constructionForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "form form-horizontal"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('constructionForm.constructionDateTypeId')
    }
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v("Date type")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.constructionDateDto.constructionDateTypeId),
      expression: "constructionDateDto.constructionDateTypeId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !_vm.buildingDto.isNonExtant,
        max: 255
      }),
      expression: "{ required: !buildingDto.isNonExtant, max: 255 }"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "constructionDateTypeId"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.constructionDateDto, "constructionDateTypeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.constructionDateTypes), function(dateType) {
    return _c('option', {
      key: dateType.constructionDateTypeId,
      domProps: {
        "value": dateType.constructionDateTypeId
      }
    }, [_vm._v("\n                                    " + _vm._s(dateType.description) + "\n                                ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('constructionForm.constructionDateTypeId')),
      expression: "errors.has('constructionForm.constructionDateTypeId')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Required")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('constructionForm.date')
    }
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v("Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.constructionDateDto.date),
      expression: "constructionDateDto.date"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !_vm.buildingDto.isNonExtant
      }),
      expression: "{ required: !buildingDto.isNonExtant }"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "date"
    },
    domProps: {
      "value": (_vm.constructionDateDto.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.constructionDateDto, "date", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('constructionForm.date')),
      expression: "errors.has('constructionForm.date')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Required")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v("Estimated")]), _vm._v(" "), _c('div', {
    staticClass: " col-md-2"
  }, [_c('div', {
    staticClass: "checkbox checkbox-inline",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.constructionDateDto.isEstimate),
      expression: "constructionDateDto.isEstimate"
    }],
    attrs: {
      "id": _vm.qaqcFieldId + 'estimateCB',
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.constructionDateDto.isEstimate) ? _vm._i(_vm.constructionDateDto.isEstimate, null) > -1 : (_vm.constructionDateDto.isEstimate)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.constructionDateDto.isEstimate,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.constructionDateDto.isEstimate = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.constructionDateDto.isEstimate = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.constructionDateDto, "isEstimate", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": _vm.qaqcFieldId + 'estimateCB'
    }
  }, [_vm._v(" ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('constructionForm.comment')
    }
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v("Comment")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.constructionDateDto.comment),
      expression: "constructionDateDto.comment"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !_vm.buildingDto.isNonExtant,
        max: 255
      }),
      expression: "{ required: !buildingDto.isNonExtant, max: 255 }"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "comment"
    },
    domProps: {
      "value": (_vm.constructionDateDto.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.constructionDateDto, "comment", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('constructionForm.comment')),
      expression: "errors.has('constructionForm.comment')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('constructionForm.comment')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "11px",
      "float": "right"
    }
  }, [_vm._v(_vm._s((_vm.constructionDateDto.comment || '').length + '/255'))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('constructionForm.source')
    }
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v("Source")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.constructionDateDto.source),
      expression: "constructionDateDto.source"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !_vm.buildingDto.isNonExtant,
        max: 255
      }),
      expression: "{ required: !buildingDto.isNonExtant, max: 255 }"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "source"
    },
    domProps: {
      "value": (_vm.constructionDateDto.source)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.constructionDateDto, "source", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('constructionForm.source')),
      expression: "errors.has('constructionForm.source')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('constructionForm.source')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "11px",
      "float": "right"
    }
  }, [_vm._v(_vm._s((_vm.constructionDateDto.source || '').length + '/255'))])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary col-md-3",
    attrs: {
      "name": "buttonDone"
    },
    on: {
      "click": function($event) {
        _vm.constructionDatesDone()
      }
    }
  }, [_vm._v("Done")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary col-md-3 pull-right",
    attrs: {
      "name": "buttonMore"
    },
    on: {
      "click": function($event) {
        _vm.constructionDatesMore()
      }
    }
  }, [_vm._v("More")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Identification")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Function and Setting")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Classification and Description")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Element")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("Material")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Construction and Alteration")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Estimated")]), _vm._v(" "), _c('th', [_vm._v("Comment")]), _vm._v(" "), _c('th', [_vm._v("Source")]), _vm._v(" "), _c('th', [_vm._v("Remove")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Download")]), _vm._v(" "), _c('th', [_vm._v("File Name")]), _vm._v(" "), _c('th', [_vm._v("Comment")]), _vm._v(" "), _c('th', [_vm._v("Uploaded By")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f12b2bf8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteForm/HistoricBuildingForm.vue
// module id = 1003
// module chunks = 1